import { RouteReuseStrategy } from "@angular/router";

export class NoReuseStrategy implements RouteReuseStrategy {
	shouldDetach() { return false; }
	store() { return null; }
	shouldAttach() { return false; }
	retrieve() { return null; }
	shouldReuseRoute(future, curr) {
		// return false to always recreate
		return future.routeConfig === curr.routeConfig && JSON.stringify(future.params) === JSON.stringify(curr.params);
	}
}